export { default as Gauge } from './SolidGauge/Gauge/Gauge'
export { default as Consumption } from './SolidGauge/Consumption/Consumption'
export { default as AbsoluteGauge } from './ClassicGauge/AbsoluteGauge/AbsoluteGauge'
export { default as GhgAbsoluteGauge } from './ClassicGauge/GhgAbsoluteGauge/GhgAbsoluteGauge'
export { default as RelativeGauge } from './ClassicGauge/RelativeGauge/RelativeGauge'
export { default as GhgRelativeGauge } from './ClassicGauge/GhgRelativeGauge/GhgRelativeGauge'
export { default as CircleGauge } from './CircleGauge/CircleGauge/CircleGauge'
export { default as EfficiencyGauge } from './CircleGauge/EfficiencyGauge/EfficiencyGauge'
